<a
  data-qa-link="kkm-history"
  [routerLink]="['/main/cto/history/' + contract?.id + '/' + kkm?.id]"
  class="kkm"
>
  <div class="wrapper">
    <div class="layout-4-column">
      <div>
        <svg-icon
          key="sim-card"
          class="orange-icon"
          *ngIf="kkm.ctoEvents[0]?.type === 'sim.card.replacement.request'"
        ></svg-icon>
      </div>
      <svg-icon key="kkt"></svg-icon>
      <div class="main-content" data-qa-block="kkm-info">
        <span class="block-title" data-qa="kkm-name">{{ kkm.internalName }}</span>
        <div class="grey-text">
          <span data-qa="kkm-model">{{ kkm.model }}</span>
          <span data-qa="kkm-year">{{ 'cto.kkm.release' | translate }} {{ kkm.year }}</span>
        </div>
        <div class="grey-text">
          <span data-qa="kkm-rnm" *ngIf="kkm.fnsKkmId"
            >{{ 'cto.kkm.rnm' | translate }} {{ kkm.fnsKkmId }}</span
          >
          <span data-qa="kkm-serial-number"
            >{{ 'cto.add.kkm.number' | translate }} {{ kkm.serialNumber }}</span
          >
          <span data-qa="kkm-id">id: {{ kkm.id }}</span>
        </div>
      </div>

      <div class="main-content status" data-qa-block="sim">
        <span class="grey-text" translate data-qa="kkm-cto-event">{{
          kkm.ctoEvents[0]?.type
        }}</span>
        <div *ngIf="kkm.ctoEvents[0]?.type === 'sim.card.replacement.request'">
          <span
            class="select_params"
            data-qa-button="accept-change-sim"
            (click)="apply($event); $event.stopPropagation()"
            translate
            >cto.kkm.apply</span
          >
          <span
            class="select_params"
            data-qa-button="reject-change-sim"
            (click)="reject($event); $event.stopPropagation()"
            translate
            >cto.kkm.reject</span
          >
        </div>
      </div>
    </div>
  </div>
</a>
